<template>
  <modal
    :value="value"
    max-width="500"
    content-class="data-wifi-form modal-device"
    :has-padding="false"
    @input="emitInput"
  >
    <div class="data-wifi-form-body">
      <form @submit.prevent="saveCredentials">
        <div class="data-wifi-form-body-header">
          <h1>Credenciais</h1>
        </div>

        <div class="data-wifi-form-body-inputs">
          <v-text-field
            v-model="form.accountName"
            name="Account Name"
            label="Account Name"
            v-validate="'required'"
            :error-messages="errors.collect('Account Name')"
          ></v-text-field>

          <v-text-field
            v-model="form.customerId"
            v-validate="'required'"
            label="Customer Id"
            name="Customer Id"
            :error-messages="errors.collect('Customer Id')"
          ></v-text-field>

          <v-text-field
            v-model="form.password"
            v-validate="'required'"
            label="Password"
            name="Password"
            :error-messages="errors.collect('Password')"
          ></v-text-field>
        </div>

        <v-card-actions class="data-wifi-form-body-actions">
          <button class="btn btn-extra-round btn-primary">Salvar</button>
        </v-card-actions>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      form: {
        accountName: undefined,
        customerId: undefined,
        password: undefined,
      },
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    establishmentId: {
      type: Number,
      required: true,
    },
  },

  watch: {},

  computed: {},

  mounted() {
    this.getCredentials();
  },

  methods: {
    setInitialData(credentials) {
      this.form = {
        accountName: credentials.accountName,
        customerId: credentials.customerId,
        password: credentials.password,
      };
    },
    emitInput(value) {
      this.$emit("input", value);
    },
    async getCredentials() {
      try {
        const credentials = await this.$api.dataWifi.getCredentials(
          this.establishmentId
        );
        if (credentials.accountName) this.setInitialData(credentials);
      } catch (error) {
        console.log(error);
      }
    },
    async saveCredentials() {
      try {
        EventBus.$emit("SHOW_SPINNER");
        const isValid = await this.$validator.validateAll();
        if (isValid) {
          await this.$api.dataWifi.saveCredentials({
            establishmentId: this.establishmentId,
            accountName: this.form.accountName,
            customerId: this.form.customerId,
            password: this.form.password,
          });
          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: "Credenciais salvas com sucesso!",
          });
          this.emitInput(false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.data-wifi-form {
  .data-wifi-form-body {
    padding: 10px 20px;

    .data-wifi-form-body-header {
      position: relative;

      h1 {
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 40px;
      }

      button {
        position: absolute;
        font-size: 30px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .data-wifi-form-body-inputs {
      width: 60%;
      margin: 0 auto 30px;
    }

    .data-wifi-form-body-actions {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
